module.exports.getInstagramCaption = (status, hashtags) => {
  return `${status}${status && hashtags ? '\n.\n.\n.\n.\n.\n' : ''}${hashtags || ''}`;
};
